import { useCallback } from 'react';
import useIsTrackEnabled from '../useIsTrackEnabled/useIsTrackEnabled';
import useVideoContext from '../useVideoContext/useVideoContext';
export default function useLocalAudioToggle() {
    const { localTracks } = useVideoContext();
    const audioTrack = localTracks.find(track => track.kind === 'audio');
    const isEnabled = useIsTrackEnabled(audioTrack);
    const toggleAudioEnabled = useCallback((shouldBeEnabled) => {
        if (audioTrack) {
            if (shouldBeEnabled !== undefined) {
                shouldBeEnabled ? audioTrack.enable() : audioTrack.disable();
            }
            else {
                audioTrack.isEnabled ? audioTrack.disable() : audioTrack.enable();
            }
        }
    }, [audioTrack]);
    return [isEnabled, toggleAudioEnabled];
}
//# sourceMappingURL=useLocalAudioToggle.js.map